"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const camelcase_1 = __importDefault(require("camelcase"));
const ramda_adjunct_1 = require("ramda-adjunct");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const camelizeKeys = (obj) => {
    if (Array.isArray(obj)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return obj.map((v) => camelizeKeys(v));
    }
    if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => (Object.assign(Object.assign({}, result), { [(0, camelcase_1.default)(key)]: camelizeKeys(obj[key]) })), {});
    }
    return obj;
};
exports.default = (input) => {
    if ((0, ramda_adjunct_1.isNilOrEmpty)(input)) {
        return input;
    }
    if ((0, ramda_adjunct_1.isString)(input) || (0, ramda_adjunct_1.isArray)(input)) {
        return (0, camelcase_1.default)(input);
    }
    if ((0, ramda_adjunct_1.isObj)(input)) {
        return camelizeKeys(input);
    }
    return input;
};
